var productCardMarkup = 
`<div class="swym-wishlist-grid">
{{#products}} 
<a href="{{du}}"aria-label="{{dt}}" class="swym-wishlist-item swym-is-anchor"><button id="swym-remove-productBtn" aria-label="Delete" title="Remove from wishlist" data-variant-id="{{epi}}" data-product-id="{{empi}}" data-list-id="{{lid}}" data-du="{{du}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button"><img src="https://cdn.shopify.com/s/files/1/0403/7695/9138/files/IOE_1.png?v=1705661482" /></button>
<div class="swym-wishlist-image-wrapper"><img alt="" class="swym-wishlist-image" src="{{iu}}"></div><div class="wish_p_info_cont">
<div class="swym-title swym-title-1">
{{dt}}
</div>
<div class="swym-product-price swym-text swym-text-1">
<div class="swym-product-final-price swym-value">
{{cu}}{{pr}}
</div>
</div>
</div>
<div class="swym-variant-title swym-text swym-title-2 swym-variant-title-spacer">
<div class="{{color_hide_not}}" style='background:{{variantinfoColor}};border-radius:100%;font-size: 0;width: 13px;height: 13px;margin-right: 10px;margin-top: 1px;'>{{variantinfoColor}}</div> {{variantinfoSize}}
</div>
<button id="swym-custom-add-toCartBtn" data-state-cart="{{#isInCart}}swym-added{{/isInCart}}"data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}" data-list-id="{{lid}}" data-du="{{du}}" class="swym-add-to-cart-btn swym-button swym-button-1 swym-is-button swym-is-button">
{{#isInCart}}ADDED TO BAG{{/isInCart}}{{^isInCart}}ADD TO BAG{{/isInCart}}
</button>
</a> 
{{/products}}
<div class="wishlist_share_btn"><a href="#" data-link="{{sharedLink}}"  onClick="copyToClipboard(this);return false;">Share</a></div>
</div>`;


function copyToClipboard(element) {
	var input = document.createElement('textarea');
	input.innerHTML = element.getAttribute("data-link");
	document.body.appendChild(input);
	input.select();
	var result = document.execCommand('copy');
	document.body.removeChild(input);
	const popup = document.querySelector('.wishlist_message_popup');
	popup.style.display = 'flex';
	setTimeout(function(){
		popup.style.display = 'none';
	},1000);
	return result;
}

function getVariantInfo(variants) {
	try {
		let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
		variantinfo;
		if (variantKeys.length > 0) {
			variantinfo = variantKeys[0];
			if (variantinfo == "Default Title") {
				variantinfo = "";
			}
		} else {
			variantinfo = "";
		}
		return variantinfo;
	} catch (err) {
		return variants;
	}
}
if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */

function swymRenderWishlist(swat) {
	swat.fetchLists({
		callbackFn: onSuccess,
		errorFn: onError
	});
	// Get wishlist items
	swat.fetch(function(products) {
		console.log(products)
		var wishlistContentsContainer = document.getElementById("wishlist-items-container");
		var formattedWishlistedProducts = products.map(function(p) {
			p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
			p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
			p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");
			return p;
		});
		var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
			products: formattedWishlistedProducts
		});
		if(wishlistContentsContainer){
			wishlistContentsContainer.innerHTML = productCardsMarkup;
			attachClickListeners();
		} else{
			console.log("Container not found, Wishlist Page element not found");
		}
		
	});
}

function onAddToCartClick(e) {
	e.preventDefault();
	var productId = e.currentTarget.getAttribute("data-product-id");
	var variantId = e.currentTarget.getAttribute("data-variant-id");
	var du = e.target.getAttribute("data-product-url");
	/*e.target.innerHTML = "ADDING..";
	window._swat.replayAddToCart({
		empi: productId,
		du: du
	}, variantId, function(c) {
		e.target.innerHTML = "ADDED TO BAG";
		e.target.setAttribute("data-state-cart", "swym-added");
		console.log("Successfully added product to cart.", c);
	}, function(e) {
		console.log('error');
		console.log(e);
	});*/
	window.location.href = du;
}

function attachClickListeners() {
	var addToCartButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
	var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
	//   Add to cart Btns
	for (var i = 0; i < addToCartButtons.length; i++) {
		addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
	}
	//   Remove Buttons
	for (var k = 0; k < removeBtns.length; k++) {
		removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
	}
	console.log("Events attached!");
}

function onRemoveBtnClick(e) {
	e.preventDefault();
	var epi = e.currentTarget.getAttribute("data-variant-id");
	var empi = e.currentTarget.getAttribute("data-product-id");
	var lid = e.currentTarget.getAttribute("data-list-id");
	var du = e.currentTarget.getAttribute("data-du");
	let product2 = {
		epi: epi,  
		empi: empi, 
		du: du
	};
	window._swat.deleteFromList(String(lid),product2,function() {
		if (!window.SwymCallbacks) {
			window.SwymCallbacks = [];
		}
		window.SwymCallbacks.push(swymRenderWishlist);
	},function(error){
		console.log("error:");
		console.log(error);
	});
	window._swat.fetch(function(products) {
		products.forEach(function(product) {

			if (epi && empi && product.epi == epi && product.empi == empi) {
				window._swat.removeFromWishList(product, function() {
					if (!window.SwymCallbacks) {
						window.SwymCallbacks = [];
					}
					window.SwymCallbacks.push(swymRenderWishlist);
				});
				console.log("lid");
				console.log(lid);
				console.log(product);
				
			}
		});
	});
}
let onSuccess = function(lists) {

  // Successfully fetched all lists 
	console.log("Fetched all Lists", lists);
	var wishlistTabsContainer = document.getElementById("wish_tabs");
	var wishlistContainer = document.getElementById("wishlist-items-container2");
	var new_html = '';
	var new_html2 = '';
	lists.forEach(function(value){
		new_html += '<li class="' + value.cts + '"><a href="#' + value.cts + '">'+ value.lname+ '</a></li>' ;
		new_html2 += '<div id="' + value.cts + '">';
		console.log("value.listcontents");
		console.log(value.listcontents);
		var formattedWishlistedProducts = value.listcontents.map(function(p) {
			p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
			p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
			p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");
			var new_var = p.variantinfo.split("/");
			new_var = new_var.reverse();
			p.variantinfoSize = new_var[0];
			p.variantinfoColor = new_var[1] == "Charcoal" ? "#36454f" : new_var[1];
			var color_hide_not = "hide";
			console.log(new_var);
			if(new_var[1].length > 0){
				color_hide_not = "";
			}

			p.color_hide_not = color_hide_not;
			return p;
		});
		
		if(formattedWishlistedProducts.length == 0){
			var productCardsMarkup = "No items found in this list";
		}
		else{
			var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
				products: formattedWishlistedProducts,
				sharedLink: 'https://racil.com/pages/swym-share-wishlist?hkey=' + value.lid + '&lid=' + value.lid + '&utm_source=swym-Wishlist&utm_medium=shared-wishlist&utm_campaign=' + value.lid
			});
			let onSuccess = (response) => {
				console.log("Successfully Marked List Public ", value.lid);
			}
			let onError = (error) => {
  // Error is an xhrObject
				console.log("Error while marking the list public", error)
			}
			window._swat.markListPublic(value.lid, onSuccess, onError);

		}

		new_html2 += productCardsMarkup;
		new_html2 += '</div>';

	});
	wishlistTabsContainer.innerHTML = new_html;
	wishlistContainer.innerHTML = new_html2;
	attachClickListeners();
	$('ul.tabs').each(function(){
		var active, content, links = $(this).find('a');
		active = links.first().addClass('active');
		console.log("links");
		console.log(links);
		content = $(active.attr('href'));
		links.not(':first').each(function () {
			$($(this).attr('href')).hide();
		});
		$(this).find('a').click(function(e){
			active.removeClass('active');
			content.hide();
			active = $(this);
			content = $($(this).attr('href'));
			active.addClass('active');
			content.show();
			attachClickListeners();
			return false;
		});
	});
}

// Define error callback
let onError = function(error) {
  // Error is an xhrObject
	console.log("Error while fetching all Lists", error);
}

function getLists(swat){
	swat.fetchLists({
		callbackFn: onSuccess,
		errorFn: onError
	});
}

/*setTimeout(function(){
$('ul.tabs').each(function(){alert('jjj');
    var active, content, links = $(this).find('a');
    active = links.first().addClass('active');
    console.log("links");
    console.log(links);
    content = $(active.attr('href'));
    links.not(':first').each(function () {
      $($(this).attr('href')).hide();
    });
    $(this).find('a').click(function(e){
      active.removeClass('active');
      content.hide();
      active = $(this);
      content = $($(this).attr('href'));
      active.addClass('active');
      content.show();
      return false;
    });
  });
},1000);*/